var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attribute",class:['color--' + _vm.getColor, { isActive: (_vm.currentlySelected === true) }],on:{"click":function($event){return _vm.clicked()}}},[_vm._v("\n  "+_vm._s(_vm.attr.name)+" "),(_vm.tooltip !== false)?_c('helptooltip',{staticClass:"attribute__help",attrs:{"followMouse":false,"link":_vm.link,"description":_vm.tooltip}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698b9412","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/AttributesNavigation/Attribute.vue
// module id = 263
// module chunks = 0